export default {
   "create-document": 'إنشاء سند مناقلة',
   "delete-document": 'حذف مناقلة',
   'are-you-sure-you-want-to-delete-the-document': 'هل أنت متأكد أنك تريد حذف هذا السند ؟'
}